export const mockExercises = [
  "Bench Press",
  "Incline Barbell Press",
  "Push-Up",
  "Close Grip Bench Press",
  "Bench Dip",
  "Barbell Floor Press",
  "Weight Plate Overhead Extensions",
  "Pull-Up",
  "Deadlift",
  "Barbell Curl",
  "Hammer Curls",
  "Chin Up",
  "Shoulder Press",
  "Shoulder Plate Press Out",
  "Upright Row",
  "Squat",
  "Standing Calf Raise",
  "Dips",
  "Incline Dumbbell Press",
  "Chest Fly",
  "Diamond Press Up",
  "Bent-Over Row",
  "Single Arm Dumbbell Row",
  "Incline Dumbbell Curl",
  "Concentration Curls",
  "Lateral Raise",
  "Shoulder Shrug",
  "Front Raises",
  "Lunge",
  "Squat Jumps",
  "Front Squat"
];